import { Text, View } from 'react-native'
import { styled } from '~/core/styled'
import { convertLineHeight, convertPercentageToNumber } from '~/utils'

export const Container = styled(View, theme => {
  return {
    base: {
      width: 'auto',
      flexDirection: 'row',
      marginTop: 'auto',
    },
  }
})

export const Title = styled(Text, theme => {
  return {
    base: {
      fontFamily: theme.fontFamily.semiBold,
      fontSize: theme.fontSizeThreepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
  }
})
